module.exports = __webpack_public_path__ + "img/ttu-coin-donation.1f32afbd.svg";